import {
  Grid,
  Binary,
  Hash,
  Compass,
  ListOrdered,
  Percent,
  GraduationCap,
  UserCheck,
  Tag,
  Calendar,
  Scale,
  BarChart3,
  Receipt,
  Clock,
  HeartPulse,
  TrendingUp,
  Award,
  Atom,
  Wallet,
  Target,
  CreditCard,
  FileText,
  Triangle,
  Variable,
  Fuel,
  DollarSign,
  Timer,
  Flame,
  Droplets,
  Activity,
  Zap,
  Box,
  CheckCircle2,
  Heart,
  Apple,
  TrendingDown,
  Ruler,
  ShieldCheck,
  BarChart2,
  Square,
  Droplet,
  Cpu,
  Thermometer,
  Coins,
  Shapes,
  BoxSelect,
  Calculator,
  Superscript,
  PieChart,
  FlaskConical,
  TestTube,
  Home,
  ArrowDownRight,
  Car,
  Utensils,
  Sparkles,
  RefreshCw,
  RotateCw,
  Table,
  Volume2,
  Users,
  Briefcase,
  UserMinus,
  Landmark,
  Mail,
} from "lucide-react";
import type { ComponentType } from "react";

const ICON_MAP: Record<string, ComponentType<{ className?: string }>> = {
  Grid,
  Binary,
  Hash,
  Compass,
  ListOrdered,
  Percent,
  GraduationCap,
  UserCheck,
  Tag,
  Calendar,
  Scale,
  BarChart3,
  Receipt,
  Clock,
  HeartPulse,
  TrendingUp,
  Award,
  Atom,
  Wallet,
  Target,
  CreditCard,
  FileText,
  Triangle,
  Variable,
  Fuel,
  DollarSign,
  Timer,
  Flame,
  Droplets,
  Activity,
  Zap,
  Box,
  CheckCircle2,
  Heart,
  Apple,
  TrendingDown,
  Ruler,
  ShieldCheck,
  BarChart2,
  Square,
  Droplet,
  Cpu,
  Thermometer,
  Coins,
  Shapes,
  BoxSelect,
  Calculator,
  Superscript,
  PieChart,
  FlaskConical,
  TestTube,
  Home,
  ArrowDownRight,
  Car,
  Utensils,
  Sparkles,
  RefreshCw,
  RotateCw,
  Table,
  Volume2,
  Users,
  Briefcase,
  UserMinus,
  Landmark,
  Mail,
};

export function CalcIcon({ name, className }: { name: string; className?: string }) {
  const IconComponent = ICON_MAP[name] || Calculator;
  return <IconComponent className={className} />;
}
